// 辞書（lib/dict の fetchDict が返す { master: { <名前空間>: … }, custom: { <名前空間>: … } }）を名前空間ごとにまとめる。
// 認証ラッパー（lib/auth.tsx）が取った辞書と、ページの getServerSideProps が取った辞書の両方を残すために使う。
// 同じ名前空間はページの方を使う（ページは自分が表示するテナントで取っている）。

type DictLayer = Record<string, unknown>;
export type DictContent = { master?: DictLayer; custom?: DictLayer };

export const mergeDict = (base: DictContent, page: DictContent | undefined): DictContent => {
  if (!page) return base;
  if (!base.master && !base.custom) return page;
  return {
    master: { ...base.master, ...page.master },
    custom: { ...base.custom, ...page.custom },
  };
};
